import React, { SFC } from "react";
import * as SuccessCheckImage from "../../assets/images/success-check-symbol.svg";
import "./SuccessfulCapture.css";

export interface SuccessfulCaptureProps {
  image?: string;
}

export const SuccessfulCapture: SFC<SuccessfulCaptureProps> = (props: SuccessfulCaptureProps) => {

  let image;
  if (!!props.image) {
    image = <img className={"SuccessfulCapture-image"} src={props.image}/>;
  } else {
    image = (null);
  }

  return (
    <div className={"SuccessfulCapture-container"}>
      {image}
      <img
        className={"SuccessfulCapture-success-icon"}
        src={SuccessCheckImage}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/doc-capture/SuccessfulCapture.tsx